/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DataCubeQuery } from '../model/dataCubeQuery';
// @ts-ignore
import { DataCubeQueryWithSettings } from '../model/dataCubeQueryWithSettings';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ExportControllerService {

    protected basePath = 'https://jissu-dev.exprit.sk/api/idc';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param id 
     * @param exportType 
     * @param lang 
     * @param dataCubeQueryWithSettings 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _export(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<object>;
    public _export(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<HttpResponse<object>>;
    public _export(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<HttpEvent<object>>;
    public _export(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling _export.');
        }
        if (exportType === null || exportType === undefined) {
            throw new Error('Required parameter exportType was null or undefined when calling _export.');
        }
        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling _export.');
        }
        if (dataCubeQueryWithSettings === null || dataCubeQueryWithSettings === undefined) {
            throw new Error('Required parameter dataCubeQueryWithSettings was null or undefined when calling _export.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'multipart/mixed'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.post<object>(`${this.configuration.basePath}/export/${encodeURIComponent(String(id))}/${encodeURIComponent(String(exportType))}/${encodeURIComponent(String(lang))}`,
            dataCubeQueryWithSettings,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param exportType 
     * @param lang 
     * @param id Array of data cube public IDs
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadDataCubes(exportType: 'json' | 'csv', lang: 'SK' | 'EN', id?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/*', context?: HttpContext}): Observable<object>;
    public downloadDataCubes(exportType: 'json' | 'csv', lang: 'SK' | 'EN', id?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/*', context?: HttpContext}): Observable<HttpResponse<object>>;
    public downloadDataCubes(exportType: 'json' | 'csv', lang: 'SK' | 'EN', id?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/*', context?: HttpContext}): Observable<HttpEvent<object>>;
    public downloadDataCubes(exportType: 'json' | 'csv', lang: 'SK' | 'EN', id?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/*', context?: HttpContext}): Observable<any> {
        if (exportType === null || exportType === undefined) {
            throw new Error('Required parameter exportType was null or undefined when calling downloadDataCubes.');
        }
        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling downloadDataCubes.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id) {
            id.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<object>(`${this.configuration.basePath}/export/bulkDownload/${encodeURIComponent(String(exportType))}/${encodeURIComponent(String(lang))}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param exportType 
     * @param lang 
     * @param dataCubeQuery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportOpendata(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQuery: DataCubeQuery, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<object>;
    public exportOpendata(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQuery: DataCubeQuery, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<HttpResponse<object>>;
    public exportOpendata(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQuery: DataCubeQuery, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<HttpEvent<object>>;
    public exportOpendata(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQuery: DataCubeQuery, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'multipart/mixed', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportOpendata.');
        }
        if (exportType === null || exportType === undefined) {
            throw new Error('Required parameter exportType was null or undefined when calling exportOpendata.');
        }
        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling exportOpendata.');
        }
        if (dataCubeQuery === null || dataCubeQuery === undefined) {
            throw new Error('Required parameter dataCubeQuery was null or undefined when calling exportOpendata.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'multipart/mixed'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.post<object>(`${this.configuration.basePath}/export/opendata/${encodeURIComponent(String(id))}/${encodeURIComponent(String(exportType))}/${encodeURIComponent(String(lang))}`,
            dataCubeQuery,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param exportType 
     * @param lang 
     * @param dataCubeQueryWithSettings 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportZip(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext}): Observable<object>;
    public exportZip(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext}): Observable<HttpResponse<object>>;
    public exportZip(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext}): Observable<HttpEvent<object>>;
    public exportZip(id: string, exportType: 'XLSX' | 'CSV' | 'JSON' | 'XML' | 'OPEN_DATA_CSV' | 'OPEN_DATA_JSON' | 'OPEN_DATA_RDF', lang: 'SK' | 'EN', dataCubeQueryWithSettings: DataCubeQueryWithSettings, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/zip', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportZip.');
        }
        if (exportType === null || exportType === undefined) {
            throw new Error('Required parameter exportType was null or undefined when calling exportZip.');
        }
        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling exportZip.');
        }
        if (dataCubeQueryWithSettings === null || dataCubeQueryWithSettings === undefined) {
            throw new Error('Required parameter dataCubeQueryWithSettings was null or undefined when calling exportZip.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/zip'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.post<object>(`${this.configuration.basePath}/export/zip/${encodeURIComponent(String(id))}/${encodeURIComponent(String(exportType))}/${encodeURIComponent(String(lang))}`,
            dataCubeQueryWithSettings,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public prepareDefaults(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public prepareDefaults(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public prepareDefaults(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public prepareDefaults(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling prepareDefaults.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/export/prepareDefaults/${encodeURIComponent(String(id))}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
